/**
 * Angi (formerly Angie's List) affiliate links per calculator slug.
 *
 * Source: 2026-06 Angi/CJ Affiliate Network referral IDs provided by the
 * site owner. Links open in a new tab with rel="sponsored nofollow noopener
 * noreferrer" so we comply with Google's affiliate-link disclosure
 * requirements (both modern `sponsored` and legacy `nofollow` tags are
 * applied for maximum safety) and don't leak referrer to the destination.
 *
 * NOTE: Only the calculators we have explicit referral IDs for are
 * included. Solar and painting are intentionally omitted (no IDs were
 * provided) — the affiliate CTA will be hidden on those calculator
 * result screens.
 */
export const ANGI_AFFILIATE_LINKS = {
  roofing: "https://www.tkqlhce.com/click-101748175-17142826",
  landscaping: "https://www.tkqlhce.com/click-101748175-17142834",
  deck: "https://www.jdoqocy.com/click-101748175-17297375",
  pool: "https://www.anrdoezrs.net/click-101748175-17297374",
  kitchen: "https://www.dpbolvw.net/click-101748175-17142833",
  bathroom: "https://www.dpbolvw.net/click-101748175-17142833",
  flooring: "https://www.dpbolvw.net/click-101748175-17142833",
  windows: "https://www.jdoqocy.com/click-101748175-17142835",
  fence: "https://www.jdoqocy.com/click-101748175-17297358",
  basement: "https://www.dpbolvw.net/click-101748175-17142833",
  hardscape: "https://www.dpbolvw.net/click-101748175-17142833",
  door: "https://www.tkqlhce.com/click-101748175-17142839",
  hvac: "https://www.tkqlhce.com/click-101748175-17142830",
  furnace: "https://www.jdoqocy.com/click-101748175-17142838",
  // Insulation isn't a stand-alone Angi vertical; reuse the generic
  // home-improvement contractor link from the homepage referral ID.
  insulation: "https://www.kqzyfj.com/click-101748175-17141197",
};

// Generic / homepage Angi link — used wherever we don't know the user's
// specific project category yet (site header, footer, decision-tool
// verdict screens that aren't tied to a single trade).
export const ANGI_HOMEPAGE_LINK = "https://www.kqzyfj.com/click-101748175-17141197";

export function getAngiLink(slug) {
  return ANGI_AFFILIATE_LINKS[slug] || null;
}
